import { render, staticRenderFns } from "./ItemE_Variant.vue?vue&type=template&id=ec3ad806"
import script from "./ItemE_Variant.vue?vue&type=script&lang=js"
export * from "./ItemE_Variant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports